
type PrimeBadgeProps = {
    cost: number;
    perSecond: number;
};

const PrimeBadge = ({ cost, perSecond }: PrimeBadgeProps) => {
    return <div className="flex items-center gap-1 w-fit rounded-full px-2 py-1 bg-badge-bg-default">
        <img src={bassets.linkle.img_webp.coin.ic_coin.webp} alt="coin" className="h-3 w-3" />
        <div className="typography-caption-body">{cost ?? ''}/{perSecond}sec</div>
    </div>;
};

export default PrimeBadge;